// extracted by mini-css-extract-plugin
export default {"centered":"DrawerForm-centered_ZAjy6"};